import { useState, useEffect } from "react";
import {
  Radio,
  FormControlLabel,
  RadioGroup,
  Typography,
  Box,
} from "@mui/material";
import { UseMotorDelivery } from "./UseMotorDelivery";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import SportsMotorsportsIcon from "@mui/icons-material/SportsMotorsports";
import { writeToLS } from "../../util/LocalStrogeService";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function DriversCom(props) {
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { GetDriversRoutes, GetActiveDrivers } = UseMotorDelivery();
  const { myPc, refresh } = UseMyPC();
  const [drivers, setDrivers] = useState();
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (props.filters.deliveryDate && props.filters.deliveryPart) {
      setProgress(true);
      GetActiveDrivers(
        props.filters.deliveryDate,
        props.filters.deliveryPart,
        (driver) => {
          if (driver) {
            setDrivers(driver);
          } else {
            setDrivers();
          }
        }
      );
    }
  }, [props.filters]);

  useEffect(() => {
    if (props.refreshDriver == true) {
      GetActiveDrivers(
        props.filters.deliveryDate,
        props.filters.deliveryPart,
        (driver) => {
          if (driver) {
            props.setRefreshDriver(false);
            setDrivers(driver);
          } else {
            props.setRefreshDriver(false);
            setDrivers();
          }
        }
      );
    }
  }, [props.refreshDriver]);

  useEffect(() => {
    if (props.refreshDriver == true && props.orders?.driverID) {
      setProgress(true);
      let model = {
        deliveryDate: props.filters.deliveryDate,
        deliveryPart: props.filters.deliveryPart,
        driverID: props.orders.driverID,
      };
      GetDriversRoutes(model, (orders) => {
        props.setChangeZoom(true);
        props.setLocations(orders.orders);
        props.setOrders(orders);
      });
    }
  }, [props.refreshDriver]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        overflowY: "auto",
        height: "100%",
      }}
      gridColumn={isSmall ? "span 12" : "span 2"}
    >
      <Typography
        variant="subtitle1"
        sx={{
          textAlign: "center",
          width: "100%",
          p: 1,
          borderBottom: "1px solid #cdcdcd",
        }}
      >
        راکبان
      </Typography>
      <Box
        sx={{
          height: "100%",
          overflowY: "auto",
          width: "100%",
          px: 0.5,
          my: 1,
        }}
      >
        <RadioGroup
          defaultValue={""}
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          value={props.orders?.driverID ?? " "}
          onChange={(event) => {
            props.setOneOrderSearch("");
            props.setroutSelect();
            props.setChangeCenter(true);
            props.setMapCenter([35.7009, 51.391241]);
            props.setOrderModel({
              ...props.orderModel,
              zoneIndex: undefined,
              orderID: undefined,
            });
            props.setAssignModel({
              ...props.assignModel,
              zoneIndex: undefined,
              orderID: undefined,
            });
            let model = {
              deliveryDate: props.filters.deliveryDate,
              deliveryPart: props.filters.deliveryPart,
              driverID: event.target.value,
            };
            setProgress(true);
            writeToLS("DriverModel", model);
            GetDriversRoutes(model, (orders) => {
              props.setChangeZoom(true);
              props.setLocations(orders.orders);
              props.setOrders(orders);
            });
          }}
        >
          {drivers &&
            drivers.map((m) => {
              return (
                <Box
                  key={m.id}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    py: 1,
                    borderBottom: "1px solid #cdcdcd",
                  }}
                >
                  <SportsMotorsportsIcon
                    sx={{ mr: 1 }}
                    color="secondary"
                    fontSize="small"
                  />
                  <FormControlLabel
                    value={m.id}
                    sx={{
                      "&.MuiFormControlLabel-root .MuiFormControlLabel-label ":
                        {
                          color: "secondary.main",
                        },
                    }}
                    control={
                      <Radio sx={{ p: 0.5 }} size="small" color="secondary" />
                    }
                    label={
                      <Typography variant="subtitle2">
                        {m.driver} ({m.orderCount})
                      </Typography>
                    }
                  />
                </Box>
              );
            })}
        </RadioGroup>
      </Box>
    </Box>
  );
}
